import { requestWithOptions } from './helper';

const basePath = import.meta.env.REACT_APP_API_ENDPOINT_UPLOAD || '/';

export const uploadLogo = async file => {
  const fileData = new FormData();
  fileData.append('file', file);

  const options = {
    method: 'POST',
    body: fileData,
    isMultipart: true,
  };
  const path = `${basePath}/logo`;

  return requestWithOptions(path, options);
};
